'use strict';

class RadioGroup extends Widget {
  _element: any;
  _buttons: any;
  _index: any;

  constructor(element: any) {
    super(element);
    this._buttons = [];
    this._index = 0;
    this._update();
  }

  _update() {
    const buttons = this._element.children('.button');

    this._buttons = [];

    for (let i = 0; i < buttons.length; ++i) {
      const button = ui.button($(buttons[i]));
      button.on('clicked', this._onItemClicked.bind(this, i));
      this._buttons.push(button);
    }

    if (this._buttons.length) {
      this._buttons[0].click();
    }
  }

  _onItemClicked(index: any) {
    this.index(index, true);
    this.emit('itemclicked', index);
  }

  index(index: any, noClick: any) {
    if (index === undefined) {
      return this._index;
    } else {
      for (let i = 0; i < this._buttons.length; ++i) {
        this._buttons[i].active(i === index);
      }

      this._index = index;

      if (!noClick) {
        this._buttons[index].click();
      }
    }
  }

  static Create() {
    return $('<div class="radiogroup" />');
  }
}

ui.RadioGroup = RadioGroup;
ui.radiogroup = ui.widgetConstructor('radiogroup', ui.RadioGroup);
